import dayjs from 'dayjs';
import { apiPath } from '../../../config';
import { dateFormatForServer } from '../../../utils/dateUtils';
import { axiosInstance } from '../AxiosInstance';

export const getMealPlan = async () => {
  return axiosInstance.get(apiPath.mealPlans);
};

export const createSchedule = async (data) => {
  return axiosInstance.post(apiPath.mealschedules, data);
};

export const deleteSchedule = async (data) => {
  console.log('deleteSchedule', JSON.stringify(data));
  return axiosInstance.delete(`${apiPath.mealschedules}/${data.date}`, {
    params: { ...data },
  });
};

export const getAllSchedule = async ({ queryKey }) => {
  const [_, language, fromDate, toDate, scheduleType] = queryKey;

  if (scheduleType === 'daily_fare') {
    return;
  }
  return axiosInstance.get(apiPath.mealschedules, {
    params: {
      language,
      scheduleType,
      fromDate,
      toDate,
    },
  });
};

export const normalizeScheduledMeals = (scheduleBuckets = []) => {
  return scheduleBuckets.flatMap((item) => {
    if (Array.isArray(item?.scheduledMeals)) {
      return item.scheduledMeals.map((meal) => {
        return {
          ...meal,
          date: item.date,
          scheduleType: item?.scheduleType,
          mealPlan: item?.mealPlan,
          mealPlanId: item?.mealPlan?.id ?? item?.mealPlan,
          mealPlanName: item?.mealPlan?.name ?? item?.mealPlan,
        };
      });
    }

    if (!item) {
      return [];
    }

    return [
      {
        ...item,
        date: item.date ?? item.dateOfSchedule,
        mealPlanId: item.mealPlanId ?? item.mealPlan?.id ?? item.mealPlan,
        mealPlanName: item.mealPlanName ?? item.mealPlan?.name ?? item.mealPlan,
      },
    ];
  });
};

export const getFutureSchedulesForMeal = async ({ mealId }) => {
  if (!mealId) {
    return [];
  }

  const fromDate = dayjs().add(1, 'day').format(dateFormatForServer);
  const toDate = dayjs().add(2, 'year').format(dateFormatForServer);
  const response = await axiosInstance.get(`${apiPath.meals}/${mealId}/schedule`, {
    params: {
      fromDate,
      toDate,
    },
  });

  return normalizeScheduledMeals(response?.data ?? [])
    .filter((schedule) => schedule?.date && schedule.date >= fromDate)
    .sort((firstSchedule, secondSchedule) => {
      return Date.parse(firstSchedule.date) - Date.parse(secondSchedule.date);
    });
};
